/**
 * TODO: document this. What does this do?
 */
if(typeof(module) !== "undefined") {
  module.exports.find = function (obj, fun) {
      for (var i = 0, r; i < obj.length; i++) {
          if (r = fun.call(obj, obj[i])) { return r; }
      }
      return null;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/carto/lib/carto/tree.js
// module id = 12
// module chunks = 6